import * as React from 'react';
import { withTheme } from 'styled-components';
import { getAttributeFromHtml } from 'utils/element';
import { ContentTypes } from 'constants/contentTypes';
import { Container } from './ContentItem.styled';
import ContentWrapper from '../ContentWrapper';
import Document from './Document';
import HotspotOnImage from './HotspotOnImage';
import ShowMore from './ShowMore';
import LinkCuration from './LinkCuration';
import AudioWrapper from './Audio/Audio.styled';
import VideoWrapper from './Video/Video.styled';
import Checklist from './Checklist';
import ChecklistItem from './Checklist/checklistItem';
import HowTo from './HowTo';

type ContentItemProps = {
  value: string;
  childrenElements: any[];
  inverted: boolean;
  theme: { [key: string]: any };
  itemId: string;
  linkTabIndex?: number;
};

export const ContentItem = ({
  value,
  inverted,
  theme,
  childrenElements,
  itemId,
  linkTabIndex
}: ContentItemProps) => (
  <Container inverted={inverted}>
    {renderContent(value, childrenElements, theme, inverted, itemId, linkTabIndex)}
  </Container>
);

export default withTheme(ContentItem);

function renderContent(
  contentHtml: any,
  childrenElements: any[],
  theme: { [key: string]: any },
  inverted: boolean,
  itemId: string,
  linkTabIndex: any
) {
  const type = getAttributeFromHtml(contentHtml, 'data-type');
  switch (type) {
    case ContentTypes.Document:
      return <Document content={contentHtml} inverted={inverted} />;
    case ContentTypes.Hotspot:
      return <HotspotOnImage content={contentHtml} />;
    case ContentTypes.ExpandableBlock:
      return (
        <ShowMore
          content={contentHtml}
          childrenElements={childrenElements}
          inverted={inverted}
          linkTabIndex={linkTabIndex}
        />
      );
    case ContentTypes.LinkCuration:
      return <LinkCuration content={contentHtml} />;
    case ContentTypes.SingleAudio:
      return <AudioWrapper dangerouslySetInnerHTML={ContentWrapper.wrap(contentHtml, theme)} />;
    case ContentTypes.VideoInTheLeft:
    case ContentTypes.VideoWithText:
    case ContentTypes.VideoInTheRight:
    case ContentTypes.SingleVideo:
      return <VideoWrapper dangerouslySetInnerHTML={ContentWrapper.wrap(contentHtml, theme)} />;
    case ContentTypes.Checklist:
      return (
        <Checklist
          content={contentHtml}
          childrenElements={childrenElements}
          inverted={inverted}
          linkTabIndex={linkTabIndex}
        />
      );
    case ContentTypes.ChecklistItem:
      return (
        <ChecklistItem
          itemId={itemId}
          content={contentHtml}
          childrenElements={childrenElements}
          inverted={inverted}
          linkTabIndex={linkTabIndex}
        />
      );
    case ContentTypes.HowTo:
      return (
        <HowTo
          content={contentHtml}
          childrenElements={childrenElements}
          inverted={inverted}
          linkTabIndex={linkTabIndex}
        />
      );
    default:
      return (
        <div
          data-test="content-default"
          dangerouslySetInnerHTML={ContentWrapper.wrap(contentHtml, theme, linkTabIndex)}
        />
      );
  }
}
